import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '../../../shared/shared.module';
import { NotificationDetailsPageRoutingModule } from './notification-details-routing.module';
import { NotificationDetailsPage } from './notification-details.page';
import { OrderedProductUnavailableItemCardComponent } from './components/ordered-product-unavailable-item-card/ordered-product-unavailable-item-card.component';
import { OrderedProductUnavailableComponent } from './components/ordered-product-unavailable/ordered-product-unavailable.component';
import { DeliveryIssueComponent } from './components/delivery-issue/delivery-issue.component';
import { ProductSubstitutionCardComponent } from './components/product-substitution-card/product-substitution-card.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    NotificationDetailsPageRoutingModule,
    SharedModule,
    TranslateModule,
  ],
  declarations: [
    NotificationDetailsPage,
    OrderedProductUnavailableComponent,
    OrderedProductUnavailableItemCardComponent,
    DeliveryIssueComponent,
    ProductSubstitutionCardComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NotificationDetailsPageModule {}
